// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1KYG5","empty":"ModalGraph_empty__2_mm-"};